import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          אודות
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          חברת  <span className='font-bold'>כדורי עיצוב ארונות</span>   הקיימת מאז שנת 2000 מתמחה בייצור ארונות מעוצבים לפי מידה ממגוון רחב של חומרי גלם איכותיים ומקפידה על שירות ויחס אישי לכל לקוח.        </p>

        <p className='text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>
          ניתן לקבוע פגישת התרשמות בחנות המפעל שלנו בבת-ים או לקבל פרטים וייעוץ בטלפון ולתכנן יחד את הארון המושלם         </p>



        <p className='text-lg font-bold max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>

          לפרטים נוספים התקשרו או שלחו הודעה ונשמח לענות על כל שאלה        </p>


      </div>

    </div>

  )

}


export default About